import EmptyCode from "!!raw-loader!./colorchiparray/Empty.tsx";
import MultipleCode from "!!raw-loader!./colorchiparray/Multiple.tsx";
import EventsCode from "!!raw-loader!./colorchiparray/Events.tsx";
import SingleCode from "!!raw-loader!./colorchiparray/Single.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Empty from "./colorchiparray/Empty";
import Multiple from "./colorchiparray/Multiple";
import Events from "./colorchiparray/Events";
import Single from "./colorchiparray/Single";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Empty", EmptyCode, Empty),
		paneComponent("Single Page", SingleCode, Single),
		paneComponent("Multiple Pages", MultipleCode, Multiple),
		paneComponent("All Events", EventsCode, Events),
	];

	return (
		<Pane
			components={components}
			imports='import {ColorChipArray} from "designSystem/index";'
			{...props}
		/>
	);
};